export const ru = {
    any: 'Любое число пересадок',
};
